var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "bg-secondary-13 rounded my-3 pl-3 py-3 d-flex" },
    [
      _c("div", { staticClass: "col-12 col-md-2 left-info__container" }, [
        _c("div", [
          _c("div", { staticClass: "color-gray-6 font-14" }, [
            _vm._v(" Fecha: ")
          ]),
          _c("span", [_vm._v(_vm._s(_vm._f("dateTime")(_vm.date)))])
        ]),
        _c("div", { staticClass: "mt-3" }, [
          _c("div", { staticClass: "color-gray-6 font-14" }, [
            _vm._v(" Añadido por: ")
          ]),
          _c("span", [_vm._v(_vm._s(_vm.user))])
        ])
      ]),
      _c("div", { staticClass: "col-12 col-md-10" }, [
        _c("div", [
          _c("div", { staticClass: "color-gray-6 font-14" }, [
            _vm._v(" Comentario: ")
          ]),
          _c("span", [_vm._v(_vm._s(_vm.comment))])
        ]),
        _c("div", { staticClass: "file-detail__container" }, [
          _c("div", { staticClass: "d-flex" }, [
            _c("div", [
              _c("div", { staticClass: "color-gray-6 font-14" }, [
                _vm._v(" Nombre del Documento: ")
              ]),
              _c("span", [_vm._v(_vm._s(_vm.fileId ? _vm.fileAlias : "-"))])
            ]),
            _c("div", { staticClass: "ml-5" }, [
              _c("div", { staticClass: "color-gray-6 font-14" }, [
                _vm._v(" Archivo: ")
              ]),
              _c("span", [_vm._v(_vm._s(_vm.fileId ? _vm.filename : "-"))])
            ])
          ]),
          _c(
            "div",
            [
              _c("action-button", {
                staticClass: "action-button",
                attrs: {
                  "class-icon": "action-icon",
                  disabled: !_vm.fileId,
                  i: "fas fa-file-download",
                  variant: "success"
                },
                on: {
                  click: function($event) {
                    return _vm.$emit("download", _vm.fileId)
                  }
                }
              })
            ],
            1
          )
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }